import ReactPaginate from "react-paginate";
import styled from "styled-components";
function TablePagination({
  count, // Number of items on current page (optional - will calculate if not provided)
  currentPage = 1,
  perPage = 20,
  total = 0,
  totalPages = 1,
  handlePageChange,
  marginTop,
  marginBottom,
}) {
  // Calculate beginning item number (1-indexed)
  const beginning = (currentPage - 1) * perPage + 1;
  
  // Calculate end item number
  // Use the actual count of items on current page if provided
  // Otherwise, calculate based on currentPage and perPage, but don't exceed total
  let end;
  if (count && count > 0) {
    // count is the number of items on the current page
    end = beginning + count - 1;
  } else {
    // Calculate end based on page and perPage, but cap at total
    const calculatedEnd = currentPage * perPage;
    end = Math.min(calculatedEnd, total);
  }
  
  // Ensure end doesn't exceed total
  end = Math.min(end, total);
  
  // Ensure beginning is valid
  const safeBeginning = total > 0 ? Math.max(1, beginning) : 0;
  
  const handlePageClick = (event) => {
    const selectedPageNumber = event.selected + 1;
    handlePageChange(selectedPageNumber);
  };

  return (
    <Wrapper marginTop={marginTop} marginBottom={marginBottom}>
      <p className="m-0" style={{ color: "#525252", fontSize: "14px" }}>
        Showing {safeBeginning} - {end} items out of {total} results found
      </p>
      <ReactPaginate
        breakLabel="..."
        nextLabel=">"
        onPageChange={handlePageClick}
        pageRangeDisplayed={5}
        pageCount={totalPages}
        previousLabel="<"
        renderOnZeroPageCount={null}
        activeLinkClassName="current"
        forcePage={currentPage - 1}
        className="pagination-themed"
      />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  margin-top: ${(props) => (props.marginTop ? props.marginTop : "2rem")};
  margin-bottom: ${(props) =>
    props.marginBottom ? props.marginBottom : "0rem"};
  padding-inline: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem 2rem;
  ul {
    list-style: none;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0;
    margin: 0;
  }
  a {
    color: #45464e;
    background: #fafafa;
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    padding: 8px 12px;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.2s ease;
    cursor: pointer;
    &:hover {
      background: var(--color-primary-soft);
      border-color: var(--color-primary);
      color: var(--color-primary);
    }
  }
  .current {
    background-color: var(--color-primary) !important;
    border-color: var(--color-primary) !important;
    color: white !important;
  }
  .previous a,
  .next a {
    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
`;

export default TablePagination;
